import React, { useMemo } from 'react'
import { Typography } from '@material-ui/core'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import {
	RuleSummaryArrow,
	RuleSummaryEligibleProducts,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'
import { BogoSameRuleState } from './types'

export function BogoSameConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<BogoSameRuleState>) {
	const names = useMemo(() => {
		const out: string[] = []
		for (const o of rule.selectedProducts) {
			if (o.productName) {
				out.push(o.productName)
			}
			if (o.productOfferedName) {
				out.push(o.productOfferedName)
			}
		}
		return out
	}, [rule.selectedProducts])

	return (
		<>
			<RuleSummaryMechanicsRow>
				<RuleSummaryStatBadge value={1} caption="acheté" minWidth={72} />
				<RuleSummaryArrow />
				<RuleSummaryStatBadge value={1} caption="offert" minWidth={72} />
				<Typography
					variant="caption"
					style={{
						color: '#9e9e9e',
						alignSelf: 'flex-end',
						paddingBottom: 4,
					}}
				>
					même produit
				</Typography>
			</RuleSummaryMechanicsRow>
			<RuleSummaryEligibleProducts names={names} />
		</>
	)
}
